<template>
  <div class="content-container">
    <filter-location-statuses-data />
    <div class="content-wrap">
      <TopMenu />
      <location-statuses />
    </div>
  </div>
</template>

<script>
import TopMenu from "../components/TopMenu.vue";
import LocationStatuses from "@/components/LocationStatuses.vue";
import FilterLocationStatusesData from "@/components/FilterLocationStatusesData.vue";

export default {
  name: "LocationStatusesView",
  components: {
    TopMenu,
    LocationStatuses,
    FilterLocationStatusesData,
  },
};
</script>

<style scoped>
.content-container {
  background-color: #f5f4f2;
}
</style>
